// extracted by mini-css-extract-plugin
export default {"rejection":"AnswerRejection_rejection__dUirR"};